<template>
  <div>
    <b-modal
      :id="`orders_currency_update_warning_${collectionId}`"
      size="lg"
      modal-class="modal-primary custom-model"
      centered
      hide-header-close
      hide-header
      hide-backdrop
      hide-footer
    >
      <div>
        <div class="pb-1 border-bottom">
          <span
            class="custom-modal-heading"
          >Collection Update Disclaimer!</span>
          <feather-icon
            class="float-right close-x-icon"
            icon="XIcon"
            size="24"
            @click="closeModal"
          />
        </div>
        <p class="mt-1 text-center product-message">
          Some SKUs with updated prices exist in orders from retailers. Would
          you like to update prices in not confirmed orders?
        </p>
      </div>
      <div>
        <div class="text-center my-1">
          <b-button
            class="mt-1 mr-2 px-sm-3 font-weight-bolder"
            variant="outline-info"
            @click="closeModal"
          >
            Cancel
          </b-button>
          <b-button
            class="mt-1 mr-2 px-sm-3 font-weight-bolder"
            variant="info"
            @click="handleDoNotUpdateOrders"
          >
            Do not update orders
          </b-button>
          <b-button
            variant="info"
            class="mt-1 px-sm-3 font-weight-bolder"
            @click="showUpdateOrdersModal"
          >
            Update orders
          </b-button>
        </div>
      </div>
    </b-modal>
    <collection-edit-modals
      :custom-id="`select_orders_for_currency_update_${collectionId}`"
      :orders="orderData"
      :update-orders="handleUpdateOrders"
      :is-saving="isSaving"
    />
  </div>
</template>
<script>
import { BModal, BButton } from 'bootstrap-vue'
import CollectionEditModals from './CollectionEditModals.vue'

export default {
  name: 'CurrencyUpdateModals',
  components: {
    BModal,
    CollectionEditModals,
    BButton,
  },
  props: {
    collectionId: {
      type: String,
      default: '',
    },
    orderData: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isSaving() {
      return this.$store.state.collection.isUploadingCurrencyBook
    },
  },
  methods: {
    handleDoNotUpdateOrders() {
      this.$emit('do-not-update-orders')
      this.$bvModal.hide(`orders_currency_update_warning_${this.collectionId}`)
    },
    handleUpdateOrders(orderIds) {
      this.$emit('update-orders', orderIds)
    },
    showUpdateOrdersModal() {
      this.$bvModal.show(`select_orders_for_currency_update_${this.collectionId}`)
    },
    closeModal() {
      this.$emit('hide')
      this.$bvModal.hide(`orders_currency_update_warning_${this.collectionId}`)
    },
  },
}
</script>
<style>
#orders_currency_update_warning_modal___BV_modal_content_ {
 box-shadow: none;
}
</style>
